import angular from 'angular';
import HomeServicesConfig from './home-services.config';
import './home-services.global.css';

export const HomeServicesAppModule = angular
  .module('app.steps.home-services-app', [])
  .config(HomeServicesConfig);
